const volunteerCampaignConfig = {
  ckKitchen: {
    id: "7018Z000002jtq0QAA",
    images: ["kitchen1.jpeg", "kitchen2.jpeg"],
  },
  doorfront: {
    id: "701UP00000JyWOgYAN",
    images: ["doorfront1.jpg", "doorfront2.jpg"],
  },
  deliveryDrivers: {
    id: "701UP00000KA6bhYAD",
    images: ["drivers/driver-onboarding.jpg"],
  },
  gala2025: {
    id:
      process.env.NODE_ENV === "production"
        ? "701UP00000Q6OboYAF"
        : "701TH00000QR0TEYA1",
    images: ["gala1.jpg"],
  },
  bike: {
    id: "701UP00000Oyq4NYAR",
    images: ["mmt_1.jpg", "mmt_2.jpg", "mmt_3.jpg"],
  },
  EOYDC2025: {
    id: "701UP00000Xj0VVYAZ",
    images: ["events/EOYDC_Winter_Wonderland.jpg"],
  },
  homeChef: { id: "7018Z000003C3MxQAK", images: [] },
};

export default volunteerCampaignConfig;
